import { Card } from "@/components/ui/card";
import { useLocalizations } from "@/hooks/useLocalizations";
import { CARDS, SPACING, TYPOGRAPHY } from "@/design-system";
import { getCountryFlag } from "@/lib/flagUtils";
import { cn } from "@/lib/utils";

interface LocationDescriptionCardProps {
  locationName: string;
  countryCode?: string | null;
  description: string | null | undefined;
}

/**
 * Location description card shown on location pages under the last
 * publication. Renders nothing when the location has no description.
 */
export const LocationDescriptionCard = ({ locationName, countryCode, description }: LocationDescriptionCardProps) => {
  const { lPages } = useLocalizations();

  const text = description?.trim();
  if (!text) return null;

  const flag = countryCode ? getCountryFlag(countryCode) : '';

  return (
    <Card id="location-description">
      <div className={cn(CARDS.horizontalCompact, SPACING.stackLg)}>
        <h2 className={cn(TYPOGRAPHY.sectionTitleLarge, 'flex items-center', SPACING.listItemGap)}>
          {flag && <span aria-hidden="true" className={TYPOGRAPHY.metricValue}>{flag}</span>}
          <span>
            {lPages('location.about_title', { name: locationName, defaultValue: 'About {{name}}' })}
          </span>
        </h2>
        <p className={cn(TYPOGRAPHY.publicationBody, 'whitespace-pre-line')}>{text}</p>
      </div>
    </Card>
  );
};

export default LocationDescriptionCard;
